import type { ReactNode } from 'react';
import { Card, Col, Row } from 'ui';

type P = {
  left: ReactNode;
  right?: ReactNode;
};

const EventJoinButtonsDetailLayout = ({ left, right }: P) => (
  <Card>
    <Row gutter="ms">
      <Col flex={1}>{left}</Col>
      {right ? <Col span={6}>{right}</Col> : null}
    </Row>
  </Card>
);

export default EventJoinButtonsDetailLayout;
